import './index.less';

import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';

import IslamicAgreementDetailsContent from '../AgreementDetailsContent';
import { Result } from 'antd';

const IslamicAgreementDetailsPage = () => {
  const { agreementId } = useParams();

  return (
    <>
      <Helmet>
        <title>Agreement Details - redCASH CEP</title>
      </Helmet>
      {agreementId ? (
        <IslamicAgreementDetailsContent agreementId={agreementId} />
      ) : (
        <Result status="404" title="404" subTitle="Sorry, agreement not found." />
      )}
    </>
  );
};

export default IslamicAgreementDetailsPage;
